import { render } from "./ColorColumn.vue?vue&type=template&id=68b1108a&scoped=true"
import script from "./ColorColumn.vue?vue&type=script&lang=js"
export * from "./ColorColumn.vue?vue&type=script&lang=js"

import "./ColorColumn.vue?vue&type=style&index=0&id=68b1108a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b1108a"]])

export default __exports__